import { forwardRef } from 'react';

import type { AgGridReactProps } from 'ag-grid-react';
import { AgGridReact } from 'ag-grid-react';

import { useDefaultGridOptions } from '@/grid';

export type DataGridProps<TData> = Omit<
  AgGridReactProps<TData>,
  'className'
> & {
  containerClassName: string;
};

const DEFAULT_COL_DEF = { sortable: true, resizable: true };

function DataGridInner<TData>(
  {
    containerClassName,
    gridOptions,
    defaultColDef,
    headerHeight = 28,
    rowHeight = 26,
    ...rest
  }: DataGridProps<TData>,
  ref: React.ForwardedRef<AgGridReact<TData>>,
) {
  const defaults = useDefaultGridOptions();

  return (
    <div className={containerClassName}>
      <AgGridReact<TData>
        ref={ref}
        gridOptions={gridOptions ?? defaults}
        defaultColDef={defaultColDef ?? DEFAULT_COL_DEF}
        headerHeight={headerHeight}
        rowHeight={rowHeight}
        {...rest}
      />
    </div>
  );
}

export const DataGrid = forwardRef(DataGridInner) as <TData>(
  props: DataGridProps<TData> & {
    ref?: React.ForwardedRef<AgGridReact<TData>>;
  },
) => ReturnType<typeof DataGridInner>;
